import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SequenceFormComponent } from '@app/components/forms/sequence/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { Sequence, SequenceCreate } from '@app/models/sequence.interface';
import { SequenceHelperService } from '@app/services/helpers/sequence-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-sequence-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        SequenceFormComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class SequenceEditPage {
  public title = 'Sequence Edit';
  formValid = signal(false);
  formValue = signal<SequenceCreate | null>(null);
  id: number;
  sequence$: Observable<Sequence>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private sequenceHelper: SequenceHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.sequence$ = this.sequenceHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.sequenceHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['sequences', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
